import axios from '../../../utils/AxiosUtils';
import i18n from '../../../i18next';
import MessageUtils from "../../../utils/MessageUtils";
import {
    LOADING,
    LOAD_QUESTIONS_SUCCESS,
    REORDER_QUESTIONS_SUCCESS,
    RESET_ANSWERS,
    LOAD_SUB_QUESTIONS_SUCCESS,
    REORDER_SUB_QUESTIONS_SUCCESS,
    RESET_SUB_QUESTIONS,
    RESET_SUB_ANSWERS,
    QUESTION_COPY,
    IS_QUESTION_COPY,
    RESET_QUESTION_COPY
} from '../../types';
import { convertStringToBoolean } from '../../../utils/CommonUtils';

export const loadQuestions = (productDraftId, mealDealProduct, posId, restaurantId) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const body = {
            mealDealProduct: mealDealProduct ? mealDealProduct : null,
            posId: posId ? posId : null,
            restaurantId: restaurantId ? restaurantId : null
        }

        const url = `/product-draft/${productDraftId}/questions`;

        if (mealDealProduct) {
            axios().post(url, body)
                .then(response => loadSubQuestionsSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadSubQuestionsFailure')));
        } else {
            axios().post(url, body)
                .then(response => loadQuestionsSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
        }
    }
}

const loadSubQuestionsSuccess = (dispatch, response, saveMessageSuccess, deleteMessageSuccess, publishMessageSuccess) => {

    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.saveQuestionSuccess'));
    }

    if (deleteMessageSuccess !== undefined && deleteMessageSuccess !== null && deleteMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.deleteQuestionSuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.publishQuestionSuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_SUB_QUESTIONS_SUCCESS, payload: response.data });
}

const loadQuestionsSuccess = (dispatch, response, saveMessageSuccess, deleteMessageSuccess, publishMessageSuccess) => {

    if (saveMessageSuccess !== undefined && saveMessageSuccess !== null && saveMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.saveQuestionSuccess'));
    }

    if (deleteMessageSuccess !== undefined && deleteMessageSuccess !== null && deleteMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.deleteQuestionSuccess'));
    }

    if (publishMessageSuccess !== undefined && publishMessageSuccess !== null && publishMessageSuccess === true) {
        MessageUtils.dispatchSuccessMessage(dispatch, i18n.t('actions:questionsActions.publishQuestionSuccess'));
    }

    dispatch({ type: LOADING, payload: false });
    dispatch({ type: RESET_ANSWERS });
    dispatch({ type: RESET_SUB_QUESTIONS });
    dispatch({ type: RESET_SUB_ANSWERS });
    dispatch({ type: LOAD_QUESTIONS_SUCCESS, payload: response.data });
}

export const saveQuestion = (state, dependsOnQuestionName, restaurantId, productDraftPosId, mealDealProduct, publishQuestionCallback) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        let dependsOnAnswerIdsArray = state.dependsOnAnswerIds.map(function (item) {
            return Number(item);
        });

        const questionData = {
            restaurantId: Number(restaurantId),
            productDraftId: state.productDraftId,
            name: state.name,
            active: convertStringToBoolean(state.active),
            description: state.description,
            minimumQuantity: !state.minimumQuantity ? null : Number(state.minimumQuantity),
            maximumQuantity: !state.maximumQuantity ? null : Number(state.maximumQuantity),
            multiIngredients: convertStringToBoolean(state.multiIngredients),
            // Add the ability for freeToppingsCount to be saved as both 0 and null(if '' or null -> set to null) if 0 -> set to 0
            freeToppingsCount: (state.freeToppingsCount === "" || state.freeToppingsCount === null) ? null : Number(state.freeToppingsCount),
            dependsOnQuestionId: state.dependsOnQuestionId,
            dependsOnAnswersIds: dependsOnAnswerIdsArray,
            multipleActivateOrDeactivate: convertStringToBoolean(state.multipleActivateOrDeactivate),
            multipleNameChange: convertStringToBoolean(state.multipleNameChange),
            multipleDescriptionChange: convertStringToBoolean(state.multipleDescriptionChange),
            mealDealProduct: mealDealProduct,
            productDraftPosId: productDraftPosId,
            answerGroups: state.answerGroups,
            ingredientQuestion: state.ingredientQuestion ? state.ingredientQuestion : null
        };

        if (questionData.dependsOnAnswersIds.length == 0 && state.dependsOnQuestionId !== -1) {
            MessageUtils.dispatchErrorMessage(dispatch, `${i18n.t(`actions:questionsActions.selectAtLeastOneItem`)}${dependsOnQuestionName}${i18n.t('actions:questionsActions.itemWithSpace')}`);
            return;
        }
        
        if (state.id === -1 || state.isCopyQuestion) {
            const originIdQuery = state.isCopyQuestion ? `?originQuestionId=${state.id}` : '';
            const url = `/question-draft${originIdQuery}`;

            axios().post(url, questionData)
                .then(response => saveQuestionSuccess(dispatch, state.productDraftId, mealDealProduct, restaurantId, questionData.productDraftId, productDraftPosId, publishQuestionCallback))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.saveQuestionFailure')));
        } else {
            const url = `/question-draft/${state.id}`;

            axios().put(url, questionData)
                .then(response => saveQuestionSuccess(dispatch, state.currentProductDraftId, mealDealProduct, restaurantId, questionData.productDraftId, productDraftPosId, publishQuestionCallback))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.saveQuestionFailure')));
        }
    }
}

const saveQuestionSuccess = (dispatch, productDraftId, mealDealProduct, restaurantId, questionDataProductDraftId, posId, publishQuestionCallback) => {

    if (publishQuestionCallback) {
        publishQuestionCallback();
        return;
    }

    const url = `/product-draft/${productDraftId}/questions`;

    const body = {
        mealDealProduct: mealDealProduct ? mealDealProduct : null,
        posId: posId ? posId : null,
        restaurantId: restaurantId ? restaurantId : null
    }

    if (mealDealProduct) {
    
        const url = `/product-draft/${questionDataProductDraftId}/questions?`;

        axios().post(url, body)
            .then(response => loadSubQuestionsSuccess(dispatch, response, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
    } else {
        axios().post(url, body)
            .then(response => loadQuestionsSuccess(dispatch, response, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
    }
};

export const deleteQuestion = (state, restaurantId, posId, mealDealProduct) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const { productDraftId, id } = state;
        const url = `/question-draft/${id}`;

        axios().delete(url)
            .then(response => deleteQuestionSuccess(dispatch, productDraftId, restaurantId, posId, mealDealProduct))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.deleteQuestionFailure')));
    }
}

const deleteQuestionSuccess = (dispatch, productDraftId, restaurantId, posId, mealDealProduct) => {

    const url = `/product-draft/${productDraftId}/questions`;

    const body = {
        mealDealProduct: mealDealProduct ? mealDealProduct : null,
        posId: posId ? posId : null,
        restaurantId: restaurantId ? restaurantId : null
    }

    if (mealDealProduct) {
        axios().post(url, body)
            .then(response => loadSubQuestionsSuccess(dispatch, response, false, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
    } else {
        axios().post(url, body)
            .then(response => loadQuestionsSuccess(dispatch, response, false, true))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
    }
};

export const publishQuestion = (state, restaurantId, posId, mealDealProduct) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/question-draft/${state.id}/publish`;

        let productDraftId = state.productDraftId;

        axios().put(url, {})
            .then(response => publishQuestionSuccess(dispatch, response, productDraftId, restaurantId, posId, mealDealProduct))
            .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.publishQuestionFailure')));
    }
}

const publishQuestionSuccess = (dispatch, response, productDraftId, restaurantId, posId, mealDealProduct) => {

    if (response.data.code === 403) {
        MessageUtils.errorMessageResponse(dispatch, response.data, i18n.t('actions:menusActions.alreadyRunningPublish'))
    } else {

        const url = `/product-draft/${productDraftId}/questions`;

        const body = {
            mealDealProduct: mealDealProduct ? mealDealProduct : null,
            posId: posId ? posId : null,
            restaurantId: restaurantId ? restaurantId : null
        }

        if (mealDealProduct) {
            axios().post(url, body)
                .then(response => loadSubQuestionsSuccess(dispatch, response, false, false, true))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
        } else {
            axios().post(url, body)
                .then(response => loadQuestionsSuccess(dispatch, response, false, false, true))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.loadQuestionsFailure')));
        }
    }
}

export const reorderQuestions = (questions, productId, isSubItem) => {
    return (dispatch) => {
        dispatch({ type: LOADING, payload: true });

        const url = `/product-draft/${productId}/questions/reorder`;

        if (isSubItem) {
            axios().put(url, questions)
                .then(response => reorderSubQuestionsSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.reorderSubQuestionsFailure')));
        } else {
            axios().put(url, questions)
                .then(response => reorderQuestionsSuccess(dispatch, response))
                .catch(error => MessageUtils.errorMessageResponse(dispatch, error.response.data, i18n.t('actions:questionsActions.reorderItemsFailure')));
        }
    }
}

const reorderSubQuestionsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_SUB_QUESTIONS_SUCCESS, payload: response.data });
}

const reorderQuestionsSuccess = (dispatch, response) => {
    dispatch({ type: LOADING, payload: false });
    dispatch({ type: REORDER_QUESTIONS_SUCCESS, payload: response.data });
}


export const saveQuestionCopy = (questionCopy) => {
    return (dispatch) => {
        dispatch({ type: QUESTION_COPY, payload: questionCopy })
    }
}

export const isQuestionCopy = (boolean) => {
    return (dispatch) => {
        dispatch({ type: IS_QUESTION_COPY, payload: boolean });
    }
}

export const resetQuestionCopy = () => {
    return (dispatch) => {

        dispatch({ type: RESET_QUESTION_COPY })
    }
}



// WEBPACK FOOTER //
// ./src/actions/restaurants/posmenu/QuestionsActions.js